export const customEditTemplate = `
<div class="k-edit-label">
    <label for="title">Title</label>
</div>
<div data-container-for="title" class="k-edit-field">
    <input type="text" class="k-input k-textbox" name="title" required="required" data-bind="value:title">
</div>
<div class="k-edit-label">
    <label for="start">Start</label>
</div>
<div data-container-for="start" class="k-edit-field">
    <input type="text" data-role="datetimepicker" data-interval="15" data-type="date" data-bind="value:start,invisible:isAllDay"
        name="start" />
    <input type="text" data-type="date" data-role="datepicker" data-bind="value:start,visible:isAllDay" name="start" />
    <span data-bind="text: startTimezone"></span>
    <span data-for="start" class="k-invalid-msg" style="display: none;"></span>
</div>
<div class="k-edit-label">
    <label for="end">End</label>
</div>
<div data-container-for="end" class="k-edit-field">
    <input type="text" data-type="date" data-role="datetimepicker" data-bind="value:end,invisible:isAllDay" name="end" data-datecompare-msg="End date should be greater than or equal to the start date"
    />
    <input type="text" data-type="date" data-role="datepicker" data-bind="value:end,visible:isAllDay" name="end" data-datecompare-msg="End date should be greater than or equal to the start date"
    />
    <span data-bind="text: endTimezone"></span>
    <span data-bind="text: startTimezone, invisible: endTimezone"></span>
    <span data-for="end" class="k-invalid-msg" style="display: none;"></span>
</div>
<div class="k-edit-label">
    <label for="isAllDay">All day event</label>
</div>
<div data-container-for="isAllDay" class="k-edit-field">
    <input type="checkbox" name="isAllDay" data-type="boolean" data-bind="checked:isAllDay">
</div>
<div class="k-edit-label">
    <label for="recurrenceRule">Repeat</label>
</div>
<div data-container-for="recurrenceRule" class="k-edit-field">
    <div data-bind="value:recurrenceRule" name="recurrenceRule" data-role="recurrenceeditor"></div>
</div>
<div class="asWrapper hidden">
    <div class="k-edit-label">
        <label for="autoSchedule">Auto Schedule</label>
    </div>
    <div data-container-for="autoSchedule" class="k-edit-field">
        <input type="checkbox" name="autoSchedule" data-type="boolean" data-bind="checked:autoSchedule">
    </div>
</div>
<div class="k-edit-label">
    <label for="description">Description</label>
</div>
<div data-container-for="description" class="k-edit-field">
    <textarea name="description" class="k-textbox" data-bind="value:description"></textarea>
</div>
<div class="k-edit-label">
    <label for="roomId">Room</label>
</div>
<div data-container-for="roomId" class="k-edit-field">
    <select id="roomId" data-bind="value:roomId" data-role="dropdownlist" data-value-field="value" data-text-field="text" >
    </select>
</div>
<div class="k-edit-label">
    <label for="reservationTypeId">Reservation Type</label>
</div>
<div data-container-for="reservationTypeId" class="k-edit-field resTypeWidth" >
    <select id="reservationTypeId" data-bind="value:reservationTypeId" data-role="dropdownlist" data-value-field="value" data-text-field="text" required data-required-msg="Please Select A Reservation Type">
    </select>
</div>


<div class="k-edit-label">
    <label for="assetIds">Resources</label>
</div>
<div data-container-for="assetIds" class="k-edit-field" >
    <select id="assetIds" data-bind="value:assetIds" data-role="multiselect" data-value-field="value" data-text-field="text" multiple="multiple" data-value-primitive="true">
    </select>
</div>

# if (isAdmin === true){ #
<div class="k-edit-label">
    <label for="ownerId">Owner</label>
</div>
<div data-container-for="ownerId" class="k-edit-field" >
    <select id="ownerId" data-bind="value:ownerId" data-role="dropdownlist" data-value-field="value" data-text-field="text" data-value-primitive="true">
    </select>
</div>
#} else { #
<div class="k-edit-label">
    <label for="ownerId">Owner</label>
</div>
<div data-container-for="ownerId" class="k-edit-field" >
    <select disabled id="ownerId" data-bind="value:ownerId" data-role="dropdownlist" data-value-field="value" data-text-field="text" data-value-primitive="true">
    </select>
</div>

#}#

<div class="k-edit-label">
    <label for="invitees">Invitees</label>
</div>

<div data-container-for="invitees" class="k-edit-field" >
    <button class="k-button k-button-icontext k-add-button" >Add New Invitee</button>
    <div id="inviteesBox"></div>
</div>


`;

// <div id="inviteesBox"></div>
// <-- <button class="k-button k-button-icontext k-add-button" >Add new record</button> -->
// <div class="k-edit-label">
//     <label for="invitees">Invitees</label>
// </div>
// <div data-container-for="invitees" class="k-edit-field" >
// <select id="#inviteesBox"></select>
// </div>


// <div class="k-edit-label">
//     <label for="invitees">Invitees</label>
// </div>
// <div data-container-for="invitees" class="k-edit-field" >
// <button class="k-button" id="addInvitees">Add Invitees</button>
// </div>
// `
// <div class="k-edit-label">
//     <label for="invitees">Invitees</label>
// </div>
// <div data-container-for="invitees" class="k-edit-field" >
//     <input class="k-textbox" id="invitees" type="textarea" data-bind="value:invitees" >
//     </input>
// </div>
// `



// WEBPACK FOOTER //
// ./src/Utilities/KendoScheduler/customEditTemplate.js